import React from "react";
import "./Header.css";
function Header() {
  return (
    <div>
      <h1 className="page-title">Character Customization</h1>
    </div>
  );
}

export default Header;
